import { render } from "./multi-tab.vue?vue&type=template&id=1b81279e&scoped=true&ts=true"
import script from "./multi-tab.vue?vue&type=script&lang=ts"
export * from "./multi-tab.vue?vue&type=script&lang=ts"

import "./multi-tab.vue?vue&type=style&index=0&id=1b81279e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b81279e"]])

export default __exports__